import { httpClient } from '@/libs/api';
import type { IProductDC } from '../dataContracts/IProductDC';

class PricingApiService {
  async getProducts(options: {
    ip?: string;
    searchParams?: Record<string, string>;
  }): Promise<IProductDC[]> {
    const { ip, searchParams = {} } = options;
    return httpClient.get<IProductDC[]>(
      `/billing/available-plans?${new URLSearchParams(searchParams).toString()}`,
      {
        headers: ip
          ? {
              'x-real-ip': ip,
            }
          : undefined,
      },
    );
  }

  async isTrialEnabled(): Promise<boolean> {
    return httpClient
      .get<{ is_trial_enabled: boolean }>(`/vars`)
      .then((res) => res.is_trial_enabled);
  }
}

export const pricingApiService = new PricingApiService();
